import * as React from 'react';

function ClosureErrorIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 78 78" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.0005 9.75C22.8462 9.75 9.75049 22.8457 9.75049 39C9.75049 55.1543 22.8462 68.25 39.0005 68.25C55.1548 68.25 68.2505 55.1543 68.2505 39C68.2505 22.8457 55.1548 9.75 39.0005 9.75ZM3.25049 39C3.25049 19.2558 19.2563 3.25 39.0005 3.25C58.7447 3.25 74.7505 19.2558 74.7505 39C74.7505 58.7442 58.7447 74.75 39.0005 74.75C19.2563 74.75 3.25049 58.7442 3.25049 39Z"
        fill="currentColor"
      />
      <path
        d="M25 25L53 53M53 25L25 53"
        stroke="currentColor"
        strokeWidth="8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

const MemoClosureErrorIcon = React.memo(ClosureErrorIcon);
export default MemoClosureErrorIcon;
